import { motion } from 'framer-motion';
import { Film, Camera, Mic, Theater, Video, Sparkles } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';

export default function ServicesPage() {
  const services = [
    {
      icon: <Film size={28} />,
      title: "Film & Television",
      description: "Full representation for lead roles, supporting characters, and guest appearances across all major networks and streaming platforms."
    },
    {
      icon: <Theater size={28} />,
      title: "Theater",
      description: "Broadway, Off-Broadway, and regional theater representation. We connect our talent with prestigious productions worldwide."
    },
    {
      icon: <Camera size={28} />,
      title: "Commercial",
      description: "Print, digital, and broadcast commercial work for national and international campaigns with top brands."
    },
    {
      icon: <Mic size={28} />,
      title: "Voice Over",
      description: "Animation, narration, audiobook, and commercial voice work opportunities for our vocally talented performers."
    },
    {
      icon: <Video size={28} />,
      title: "New Media",
      description: "Content creation, streaming platforms, and digital entertainment opportunities in the evolving media landscape."
    },
    {
      icon: <Sparkles size={28} />,
      title: "Career Development",
      description: "Personal branding, media training, coaching referrals, and strategic career planning for long-term success."
    }
  ];

  return (
    <div>
      <Header />
      
      <div className="page-header" data-testid="services-header">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <p className="section-subtitle">What We Offer</p>
            <h1 className="section-title">Our Services</h1>
            <p className="section-description">
              Comprehensive talent management and representation across all entertainment sectors.
            </p>
          </motion.div>
        </div>
      </div>

      <section className="section section-dark" data-testid="services-grid">
        <div className="container">
          <div className="services-grid">
            {services.map((service, index) => (
              <motion.div 
                key={index}
                className="card service-card"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                data-testid={`service-card-${index}`}
              >
                <div className="service-icon">{service.icon}</div>
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className="section section-surface" data-testid="process-section">
        <div className="container">
          <motion.div 
            className="section-header"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <p className="section-subtitle">How We Work</p>
            <h2 className="section-title">Our Process</h2>
          </motion.div>

          <div className="services-grid">
            {[
              {
                step: "01",
                title: "Discovery",
                description: "We get to know you—your goals, strengths, and unique qualities that make you stand out."
              },
              {
                step: "02",
                title: "Strategy",
                description: "Together, we develop a personalized career strategy aligned with your aspirations."
              },
              {
                step: "03",
                title: "Execution",
                description: "We actively pitch you for opportunities and guide you through every step of the process."
              }
            ].map((item, index) => (
              <motion.div 
                key={index}
                className="card service-card"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                data-testid={`process-card-${index}`}
              >
                <div style={{ 
                  fontSize: '3rem', 
                  fontFamily: 'Playfair Display, serif',
                  color: 'var(--primary)',
                  marginBottom: '1rem'
                }}>
                  {item.step}
                </div>
                <h3 className="service-title">{item.title}</h3>
                <p className="service-description">{item.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
